import { TranscriptEmptyStateProps } from '../types';

export function TranscriptEmptyState({ message }: TranscriptEmptyStateProps) {
  return (
    <div className="flex h-full items-center justify-center text-sm text-slate-500">
      <p>{message}</p>
    </div>
  );
}
